import React, { useEffect } from 'react';
import Dropdown from '../Dropdown';
import Icon from '../Icons/Icon';
import { Link, useNavigate } from 'react-router-dom';
import { classNames } from '../../Services/helpers';
import { useHelp, scrollDirection } from '../Help';
import { useSession } from '../Session';
import { useStatusBarColour } from '../Mobile';

const TopBar = ({left, title, right, dropdownIcon, dropdownOptions, dropdownDisabled, dropdownLoading, shadow = true}) => {
    const {scrollHook} = useHelp();
    const {showRedesign, showDarkMode} = useSession();

    let dropdown = null;
    if (dropdownOptions) {
        dropdown = <Dropdown {...{
            disabled: dropdownDisabled,
            icon: dropdownIcon,
            options: dropdownOptions,
            loading: dropdownLoading
        }} />;
    }

    useEffect(() => {
        let t = '';
        if (typeof title === 'string') {
            t = ' | '+title;
        }
        window.document.title = 'getSoapy'+t;
    }, [title]);

    useStatusBarColour((showRedesign && showDarkMode) ? '#1d293d' : null);

    return <>
        <div id="top-bar"
            className={classNames(
                'sticky top-0 left-0 z-30 w-full border-b dark:border-b-slate-700 overflow-visible',
                (showRedesign && showDarkMode) && 'surface-1',
                (!showRedesign && shadow) && 'shadow-md dark:shadow-none',
            )}>
            <div className="w-full page-container flex justify-between items-center px-3 py-2">
                <LeftBtn left={left} />
                <h1
                    onClick={() => scrollHook.invoke(scrollDirection.TOP)}
                    className="grow mx-3 whitespace-normal text-center w-full max-h-10 text-brand truncate cursor-pointer">
                    {title}
                </h1>
                <div className="shrink-0">
                    {right ?? dropdown ?? <>&nbsp;</>}
                </div>
            </div>
        </div>

    </>
}

const LeftBtn = ({left}) => {
    const navigate = useNavigate();
    const {showRedesign} = useSession();

    if (left === null || left === undefined) {
        return <>&nbsp;</>
    }

    if (left === 'BackBtn') {
        return <button onClick={() => doBackBtn(navigate)} className="h-full my-auto">
            <Icon icon="LeftChevron" theme="solid"  size="1x" inline />
        </button>
    }

    if (left === 'Home') {
        return <button onClick={() => navigate('/')} className="h-full my-auto">
            <Icon icon="LeftChevron" theme="solid"  size="1x" inline />
        </button>
    }

    if (left === 'Settings') {
        const to = showRedesign ? '/settings' : '/more';
        return <button onClick={() => navigate(to)} className="h-full my-auto">
            <Icon icon="LeftChevron" theme="solid"  size="1x" inline />
        </button>
    }

    if (typeof left === 'string') {
        return <Link to={left} className="h-full my-auto">
            <Icon icon="LeftChevron" theme="solid"  size="1x" inline />
        </Link>
    }

    return left;
}

const doBackBtn = (navigate) => {
    if (window.location.search) {
        const urlParams = new URLSearchParams(window.location.search);
        const backParam = urlParams.get('_back');
        if (backParam) {
            navigate(backParam);
            return;
        }
    }

    // window.history.back()
    navigate(-1)
}

export default TopBar;
